import EventEmitter from 'events'

export const emitter = new EventEmitter()

export default {
  install (Vue, options) {
    Vue.mixin({ beforeCreate () {
      this.$emitter = emitter
    }})
  }
}



// WEBPACK FOOTER //
// ./src/extensions/emitter.js